import { makeAutoObservable } from "mobx";

export default class AuthStore {
    constructor() {
        this._isAuth = false;
        this._isLoading = true;
        this._user = {};
        this._userName = "";
        this._role = "";

        makeAutoObservable(this);
    }

    setIsAuth(value) {
        this._isAuth = value;
    }

    setIsLoading(value) {
        this._isLoading = value;
    }

    setUser(user) {
        this._user = user || {};
    }

    setUserName(userName) {
        this._userName = userName || "";
    }

    setRole(role) {
        this._role = role || "";
    }

    reset() {
        this.setIsAuth(false);
        this.setIsLoading(false);
        this.setUser({});
        this.setUserName("");
        this.setRole("");
    }

    get user() {
        return this._user;
    }

    get userName() {
        return this._userName;
    }

    get role() {
        return this._role;
    }

    get isAuth() {
        return this._isAuth;
    }

    get isLoading() {
        return this._isLoading;
    }
}
